/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Subscription_Promotion_Trial_Extend_TitleInputs */

const en_dialog_subscription_promotion_trial_extend_title = /** @type {(inputs: Dialog_Subscription_Promotion_Trial_Extend_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You Are About to Lose This One‑Time Offer`)
};

const ar_dialog_subscription_promotion_trial_extend_title = /** @type {(inputs: Dialog_Subscription_Promotion_Trial_Extend_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أنت على وشك أن تخسر هذا العرض الذي يُقدم لمرة واحدة فقط`)
};

const de_dialog_subscription_promotion_trial_extend_title = /** @type {(inputs: Dialog_Subscription_Promotion_Trial_Extend_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie sind dabei, dieses einmalige Angebot zu verlieren`)
};

const es_dialog_subscription_promotion_trial_extend_title = /** @type {(inputs: Dialog_Subscription_Promotion_Trial_Extend_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estás a punto de perder esta oferta única`)
};

const fr_dialog_subscription_promotion_trial_extend_title = /** @type {(inputs: Dialog_Subscription_Promotion_Trial_Extend_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ne laissez pas passer cette offre unique`)
};

const it_dialog_subscription_promotion_trial_extend_title = /** @type {(inputs: Dialog_Subscription_Promotion_Trial_Extend_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stai per perdere questa offerta unica`)
};

const ja_dialog_subscription_promotion_trial_extend_title = /** @type {(inputs: Dialog_Subscription_Promotion_Trial_Extend_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この1回限りのオファーは失効します`)
};

const ko_dialog_subscription_promotion_trial_extend_title = /** @type {(inputs: Dialog_Subscription_Promotion_Trial_Extend_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`다시는 없을 혜택을 포기하시겠어요?`)
};

const pt_br_dialog_subscription_promotion_trial_extend_title = /** @type {(inputs: Dialog_Subscription_Promotion_Trial_Extend_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você está prestes a perder esta oferta única`)
};

const ru_dialog_subscription_promotion_trial_extend_title = /** @type {(inputs: Dialog_Subscription_Promotion_Trial_Extend_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы можете потерять это единовременное предложение`)
};

const th_dialog_subscription_promotion_trial_extend_title = /** @type {(inputs: Dialog_Subscription_Promotion_Trial_Extend_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณกำลังจะสูญเสียข้อเสนอที่มีแค่ครั้งเดียวนี้ไป`)
};

const tr_dialog_subscription_promotion_trial_extend_title = /** @type {(inputs: Dialog_Subscription_Promotion_Trial_Extend_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu Tek Seferlik Teklifi Kaybetmek Üzeresin`)
};

const zh_cn_dialog_subscription_promotion_trial_extend_title = /** @type {(inputs: Dialog_Subscription_Promotion_Trial_Extend_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`放弃后
此优惠即失效`)
};

const zh_tw_dialog_subscription_promotion_trial_extend_title = /** @type {(inputs: Dialog_Subscription_Promotion_Trial_Extend_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`放棄後
此優惠即失效`)
};

/**
* | output |
* | --- |
* | "You Are About to Lose This One‑Time Offer" |
*
* @param {Dialog_Subscription_Promotion_Trial_Extend_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_subscription_promotion_trial_extend_title = /** @type {((inputs?: Dialog_Subscription_Promotion_Trial_Extend_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Subscription_Promotion_Trial_Extend_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_subscription_promotion_trial_extend_title(inputs)
	if (locale === "ar") return ar_dialog_subscription_promotion_trial_extend_title(inputs)
	if (locale === "de") return de_dialog_subscription_promotion_trial_extend_title(inputs)
	if (locale === "es") return es_dialog_subscription_promotion_trial_extend_title(inputs)
	if (locale === "fr") return fr_dialog_subscription_promotion_trial_extend_title(inputs)
	if (locale === "it") return it_dialog_subscription_promotion_trial_extend_title(inputs)
	if (locale === "ja") return ja_dialog_subscription_promotion_trial_extend_title(inputs)
	if (locale === "ko") return ko_dialog_subscription_promotion_trial_extend_title(inputs)
	if (locale === "pt_br") return pt_br_dialog_subscription_promotion_trial_extend_title(inputs)
	if (locale === "ru") return ru_dialog_subscription_promotion_trial_extend_title(inputs)
	if (locale === "th") return th_dialog_subscription_promotion_trial_extend_title(inputs)
	if (locale === "tr") return tr_dialog_subscription_promotion_trial_extend_title(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_subscription_promotion_trial_extend_title(inputs)
	return zh_tw_dialog_subscription_promotion_trial_extend_title(inputs)
});